export default [
  {
    path: "/course-list",
    component: (resolve) => require(["@/vuepage/edu-manage/course/list.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "课程列表",
        activeRoute: "/course-list",
      },
    ],
  },
  {
    path: "/course-add",
    component: (resolve) => require(["@/vuepage/edu-manage/course/add.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增课程",
        activeRoute: "/course-list",
      },
    ],
  },
  {
    path: "/course-stu",
    component: (resolve) => require(["@/vuepage/edu-manage/course/stu.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "学员列表",
        activeRoute: "/course-stu",
      },
    ],
  },
  {
    path: "/offline-exam",
    component: (resolve) => require(["@/vuepage/edu-manage/offlineExam/list.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "线下考试列表",
        activeRoute: "/offline-exam",
      },
    ],
  },
  {
    path: "/offline-add",
    component: (resolve) => require(["@/vuepage/edu-manage/offlineExam/add.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增考试",
        activeRoute: "/offline-add",
      },
    ],
  },
  {
    path: "/offline-detail",
    component: (resolve) => require(["@/vuepage/edu-manage/offlineExam/detail.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "考试详情",
        activeRoute: "/offline-exam",
      },
    ],
  },
  {
    path: "/online-exam",
    component: (resolve) => require(["@/vuepage/edu-manage/onlineExam/testPaper.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "线上考试列表",
        activeRoute: "/online-exam",
      },
    ],
  },
  {
    path: "/paper-subject",
    component: (resolve) => require(["@/vuepage/edu-manage/onlineExam/paperSubject.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "题目管理",
        activeRoute: "/online-exam",
      },
    ],
  },
  {
    path: "/online-topic",
    component: (resolve) => require(["@/vuepage/edu-manage/onlineExam/topicList.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "题库管理",
        activeRoute: "/online-topic",
      },
    ],
  },
  {
    path: "/sel-subject",
    component: (resolve) => require(["@/vuepage/edu-manage/onlineExam/topicList.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增题目",
        activeRoute: "/online-topic",
      },
    ],
  },
  {
    path: "/topic-add",
    component: (resolve) => require(["@/vuepage/edu-manage/onlineExam/addTopic.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增题目",
        activeRoute: "/online-topic",
      },
    ],
  },
  {
    path: "/topic-record",
    component: (resolve) => require(["@/vuepage/edu-manage/onlineExam/record.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "填写记录",
        activeRoute: "/online-exam",
      },
    ],
  },
  {
    path: "/exam-subject",
    component: (resolve) => require(["@/vuepage/edu-manage/examSubject/testPaper.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "考卷科目",
        activeRoute: "/exam-subject",
      },
    ],
  },
  {
    path: "/certificate",
    component: (resolve) => require(["@/vuepage/edu-manage/certificate/list.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "证书列表",
        activeRoute: "/certificate",
      },
    ],
  },
  {
    path: "/certificate-add",
    component: (resolve) => require(["@/vuepage/edu-manage/certificate/add.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增证书",
        activeRoute: "/certificate",
      },
    ],
  },
  {
    path: "/distribution",
    component: (resolve) => require(["@/vuepage/edu-manage/certificate/distribution.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "发放名单",
        activeRoute: "/distribution",
      },
    ],
  },
  {
    path: "/distribution-add",
    component: (resolve) => require(["@/vuepage/edu-manage/certificate/addDistribution.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增发放名单",
        activeRoute: "/distribution",
      },
    ],
  },
  {
    path: "/sign-list",
    component: (resolve) => require(["@/vuepage/edu-manage/sign/list.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "签到列表",
        activeRoute: "/sign-list",
      },
    ],
  },
  {
    path: "/sign-record",
    component: (resolve) => require(["@/vuepage/edu-manage/sign/record.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "签到记录",
        activeRoute: "/sign-record",
      },
    ],
  },
  {
    path: "/make-up",
    component: (resolve) => require(["@/vuepage/edu-manage/make-up.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "补课申请",
        activeRoute: "/make-up",
      },
    ],
  },
  {
    path: "/paper-cate",
    component: (resolve) => require(["@/vuepage/edu-manage/paperCate/list.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "考卷分类",
        activeRoute: "/paper-cate",
      },
    ],
  },
  {
    path: "/paper-cate-add",
    component: (resolve) => require(["@/vuepage/edu-manage/paperCate/add.vue"], resolve),
    meta: [
      {
        name: "教务管理",
      },
      {
        name: "新增分类",
        activeRoute: "/paper-cate",
      },
    ],
  },
];
